module.exports = window.CKEDITOR;


//////////////////
// WEBPACK FOOTER
// external "window.CKEDITOR"
// module id = nAIH
// module chunks = 64